import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";
import Accounting from "./Accounting";

const Stack = createStackNavigator();

export interface BookingStackProps {}

const AccountingStack: React.FC<BookingStackProps> = () => {
  const { t, i18n } = useTranslation();
  return (
    <Stack.Navigator>
       <Stack.Screen
        name="AccountingScreen"
        component={Accounting}
        options={{
          title: t("HEADER_ACCOUNTING"),
          headerStyle: {
            backgroundColor: "#D71D9A",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
        }}
      /> 
    </Stack.Navigator>
  );
};

export default AccountingStack;